/// <amd-module name="Search/Code/Components/Overlay" />

import * as React from "react";
import * as SharedOverlay from "Search/Shared/Components/SearchOverlay";
import * as Resources from "Search/Shared/Resources";
import * as Container from "Search/Shared/Base/Container";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Code/Flux/StoresHub"
import { SearchStatus } from "Search/Shared/Base/Stores/SearchStore";

export const OverlayContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    ["searchStore"],
    ({ searchStoreState }, props) => {
        const element: JSX.Element | null = searchStoreState.searchStatus === SearchStatus.Loading && !searchStoreState.fetchMoreScenario
            ? <SharedOverlay.SearchOverlay spinnerText={Resources.FetchingResultsLabel} />
            : null;

        return element;
    });